export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7673.1a8dda99.jpg";